export const FETCH_ADMIN = 'FETCH_ADMIN'
export const FETCH_ADMIN_SUCCESS = 'FETCH_ADMIN_SUCCESS'
export const FETCH_ADMIN_FAILED = 'FETCH_ADMIN_FAILED'
export const ADMIN_SIGN_IN = 'ADMIN_SIGN_IN'
export const ADMIN_SIGN_IN_FAILED = 'SIGN_IN_FAILED'
export const ADMIN_SIGN_OUT = 'ADMIN_SIGN_OUT'
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR'
